export default __webpack_public_path__ + "192ea780581a9c825784fcd261db2f8e.png";